// extracted by mini-css-extract-plugin
export default {"arrow":"order-arrow_arrow__6nYgD","arrowTypeBi":"order-arrow_arrowTypeBi__jA9yF","ascOrder":"order-arrow_ascOrder__qMSth"};